<template>
  <div :class="b()">
    <div :class="b('toolbar')" class="om-hairline-top-bottom">
      <slot name="buttons">
        <div :class="b('cancel')" v-if="pCancelText" @click="$emit('cancel')">{{ pCancelText }}</div>
        <div :class="b('title')" class="om-ellipsis" v-if="pTitle" v-text="pTitle" />
        <div :class="b('confirm')" v-if="pConfirmText" @click="$emit('confirm')">{{ pConfirmText }}</div>
      </slot>
    </div>
    <div v-if="pLoading" :class="loading">
      <loader />
    </div>
    <slot/>
  </div>
</template>
<script>
import create from 'omui/components/utils/create'

export default create({
  name: 'confirm-buttons',
  props: {
    pCancelText: { type: String, default: '' },
    pConfirmText: {
      type: String,
      default: '确定'
    },
    pTitle: {
      type: String,
      default: '',
    },
    pLoading: {
      type: Boolean,
      default: false,
    },
  },
})
</script>




// WEBPACK FOOTER //
// src/plugins/jscom/omui/combines/confirm-buttons/index.vue